export function chunkArray<T>(arr: T[], chunkSize: number) {
	if (chunkSize <= 0) throw 'Invalid chunk size';
	const chunked = [] as T[][];
	for (let i = 0; i < arr.length; i += chunkSize) chunked.push(arr.slice(i, i + chunkSize));
	return chunked;
}
